import { USER_NAME_STORAGE_KEY } from './constants';

let list = localStorage.getItem('presentation-products');
try {
  if (list) list = JSON.parse(list);
} catch (e) {
  list = [];
}
export default {
  list: list || [],
  userName: localStorage.getItem(USER_NAME_STORAGE_KEY) || null
};
